<div class="tab-container" #tabsRef>
  <mat-tab-group [selectedIndex]="selectedTabIndex" (selectedIndexChange)="onTabChange($event)"
    mat-stretch-tabs="false">
    <mat-tab *ngFor="let tab of tabs; let i=index">
      <ng-template mat-tab-label>
        <div class="tab-label" [ngClass]="{ 'active-tab': selectedTabIndex === i }">
          <mat-icon  class="material-symbols-outlined" [ngClass]="{ 'active-icon': selectedTabIndex === i }" >{{ tab.icon }}</mat-icon>
          <span [ngClass]="{ 'active-label': selectedTabIndex === i }">{{ tab.title }}</span>
        </div>
      </ng-template>
    </mat-tab>
  </mat-tab-group>
</div>

<div class="container">
  <router-outlet></router-outlet>
</div>